export default function swiperjs() {
  /**
   * Swiper
   */
  (function ($) {
    // const swiper = new Swiper('.p-main-visual__slider', {
    //   loop: true,
    //   autoplay: {
    //     delay: -1,
    //     disableOnInteraction: false
    //   },
    //   freeMode: true,
    //   speed: 10000,
    //   slidesPerView: 'auto',
    //   grabCursor: true,
    //   mousewheelControl: true,
    //   keyboardControl: true,
    //   allowTouchMove: false,
    //   // navigation: {
    //   //   nextEl: '.p-main-visual__slider-next',
    //   //   prevEl: '.p-main-visual__slider-prev',
    //   // },
    //   // pagination: {
    //   //   el: ".p-main-visual__slider-pagination",
    //   //   clickable: true,
    //   // }
    // });

    // #works-slider
    const worksSlider = new Swiper('#works-slider', {
      loop: true,
      // autoplay: {
      //   delay: 5000
      // },
      autoplay: false,
      speed: 300,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
    });
  })(jQuery);
}
